<section class="ngx-json-viewer">
  <section
    *ngFor="let segment of segments"
    [ngClass]="['segment', 'segment-type-' + segment.type]">
    <section
        *ngIf="segment.visible"
        class="line-wrapper"
    >
      <div [ngClass]="['icon', 'icon_' + segment.status]"></div>
      <section
          [style]="segment.style"
          (click)="toggle(segment)"
          [ngClass]="{
        'segment-main': true,
        'expandable': isExpandable(segment),
        'expanded': segment.expanded
      }">
        <div *ngIf="isExpandable(segment)" class="toggler"></div>
        <span class="segment-key">{{ segment.key }}</span>
        <span class="segment-separator">: </span>
        <span *ngIf="!segment.expanded || !isExpandable(segment)" class="segment-value">{{ segment.value }}</span>
        <span *ngIf="
          segment.type === 'object'
          && !segment.path.includes('comment')
          && !segment.path.startsWith('pcb_')
        " class="info-button" (click)="$event.stopPropagation(); commentPath = segment.path;">i</span>
      </section>

    </section>
  </section>
  <div *ngIf="commentPath !== ''" class="comment-add-wrapper">
    <div innerText="X" class="comment-add-close"></div>
    <div [innerText]="commentPath" class="comment-add-path"></div>
    <select (change)="changeCommentStatus($event.target.value)" class="comment-add-status">
      <option>Okay</option>
      <option>2. Choice</option>
      <option>Reject</option>
    </select>
    <textarea [value]="commentText" (change)="changeCommentText($event.target.value)" class="comment-add-text">

    </textarea>
    <div class="comment-add-buttons">
      <button (click)="postChange()" class="comment-add-button-confirm">Okay</button>
      <button (click)="resetComment()" class="comment-add-button-abort">Abort</button>
    </div>
  </div>
</section>
